"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var a=require("@material-ui/core/styles");let b=a.makeStyles(a=>({thumbArrow:{"&:first-child":{transform:"rotate(180deg)"},color:a.palette.common.blue400,fill:"currentColor"}}));exports.default=b
//# sourceMappingURL=styles.js.map
